var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.286 6a2.487 2.487 0 0 0-2.487 2.487v7.212h4.972V8.486A2.487 2.487 0 0 0 19.286 6zm-5.07 19.589a2.582 2.582 0 0 0 2.583-2.583v-7.308h-5.164v-4.84a1.626 1.626 0 0 0-3.252 0v4.84H4.177v-1.582a1.588 1.588 0 1 0-3.177 0v1.588h3.176v2.454a2.104 2.104 0 0 0 4.208 0V15.7h3.25v7.307a2.582 2.582 0 0 0 2.583 2.582zM31 17.293a1.588 1.588 0 1 1-3.177 0v-1.588H31v1.588zm-5.974 4.197a1.626 1.626 0 0 1-3.252 0V15.7h3.252v5.79zM26.46 9.043c-.792 0-1.434.642-1.434 1.434v5.222h2.869v-5.222c0-.792-.642-1.434-1.435-1.434z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMln);
export default __webpack_public_path__ + "static/media/MLN.f24954cb44973c9f73a24e139ee60000.svg";
export { ForwardRef as ReactComponent };